import { createAction } from '@reduxjs/toolkit'

export const setPreselectedProductionOrderId = createAction<string | undefined>('SET_PRESELECTED_PRODUCTION_ORDER_ID')

export const setPreselectedProductId = createAction<string | undefined>('SET_PRESELECTED_PRODUCT_ID')
